<ng-container *ngIf="icon">
	<ng-container [ngSwitch]="icon.type">
		<mat-icon
			*ngSwitchCase="'material'"
			[ngClass]="cssClass"
			matTooltip="{{ icon.toolTip | translate }}"
		>{{ name }}</mat-icon>
		<i
			*ngSwitchCase="'fa'"
			class="sdp-fa-icon fa fa-{{ name }}"
			[ngClass]="cssClass"
			matTooltip="{{ icon.toolTip | translate }}"
		></i>
		<img
			*ngSwitchCase="'image'"
			[ngClass]="cssClass"
			[src]="icon.src"
			[alt]="name"
			matTooltip="{{ icon.toolTip | translate }}"
			class="sdp-img-icon"
		>
	</ng-container>
	<div
		*ngIf="!!(icon.logo)"
		class="{{ logoCssClass }}"
	>{{ icon.logoName }}</div>
</ng-container>